import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';
import { toFacilityHistoryList, toFacilityList } from '../utils/facility-lms.utils';

const BASE = `${PORTAL_API_BASE_URL}/api/admin/location-delivery-lms`;

const req = (opts) => request({ ...opts, throw400Error: true });

export const fetchFacilities = async () => {
  const response = await req({ url: BASE, method: 'GET' });
  return toFacilityList(response);
};

export const fetchFacilityHistory = async (locationKey) => {
  const response = await req({
    url: `${BASE}/${encodeURIComponent(locationKey)}/history`,
    method: 'GET',
  });
  return toFacilityHistoryList(response);
};

export const switchFacilityLms = async (locationKey, deliveryLms) =>
  req({
    url: `${BASE}/${encodeURIComponent(locationKey)}/switch`,
    method: 'POST',
    body: JSON.stringify({ deliveryLms }),
  });
